const ParagraphsBlock = ({children, className = ''}) => (
    <div className={"w-11/12 mx-auto flex flex-col gap-2 " + className}>
        {children}
    </div>
)

export default ParagraphsBlock